import { __assign } from "tslib";
import * as React from 'react';
import ServiceSummary from '../../ServiceSummary';
import { useTranslation } from 'react-i18next';
import { SeatSelection } from '../../Icons';
import Aeroexpress from './Extra/Aeroexpress';
import Insurance from './Extra/Insurance';
import { useContext } from 'react';
import { CartContext } from '../Cart';
import BusinessLounge from './Extra/BusinessLounge';
import Animal from './Extra/Animal';
import { getTotalPrice } from '../../utils';
var Extra = function (props) {
    var t = useTranslation('Cart').t;
    var totalPrices = useContext(CartContext).totalPrices;
    var prices = [totalPrices.aeroexpress, totalPrices.businessLounge, totalPrices.insurance, totalPrices.animals];
    var extraTotalPrice = getTotalPrice(prices, function (price) { return price; });
    if (!(extraTotalPrice === null || extraTotalPrice === void 0 ? void 0 : extraTotalPrice.amount)) {
        return null;
    }
    return (React.createElement(ServiceSummary, { group: {
            header: t('Extra'),
            icon: SeatSelection,
            totalPrice: extraTotalPrice
        } },
        totalPrices.aeroexpress !== null && React.createElement(Aeroexpress, __assign({}, props)),
        totalPrices.insurance !== null && React.createElement(Insurance, __assign({}, props)),
        totalPrices.businessLounge !== null && React.createElement(BusinessLounge, __assign({}, props)),
        totalPrices.animals !== null && React.createElement(Animal, __assign({}, props))));
};
export default Extra;
